

const LOCATION_MARSEILLE = {
  address: "",
  district: "1er Arrondissement",
  city: "Marseille",
  label: "Marseille (13001) 1er Arrondissement",
  lat: 43.29337,
  lng: 5.37133,
  zipcode: "13001",
  geo_source: "city",
  geo_provider: "here",
  region: "21",
  region_label: "Provence-Alpes-Côte d'Azur",
  department: "13",
  dpt_label: "Languedoc-Roussillon",
  country: "FR",
};

const LOCATION_PARIS = {
  address: "",
  city: "Paris",
  country: "FR",
  district: "1er Arrondissement",
  geo_provider: "here",
  geo_source: "city",
  label: "Paris (75001) 1er Arrondissement",
  lat: 48.85717,
  lng: 2.3414,
  zipcode: "75001",
};

const LOCATION_BORDEAUX = {
  address: "",
  city: "Bordeaux",
  country: "FR",
  district: "",
  geo_provider: "here",
  geo_source: "city",
  label: "Bordeaux (33000)",
  lat: 44.8367,
  lng: -0.58105,
  zipcode: "33000",
};

const LOCATION_TOULOUSE = {
  address: "",
  city: "Toulouse",
  country: "FR",
  district: "",
  geo_provider: "here",
  geo_source: "city",
  label: "Toulouse (31000)",
  lat: 43.60579,
  lng: 1.44863,
  zipcode: "31000",
};

const LOCATION_LYON = {
  address: "",
  district: "2e Arrondissement",
  city: "Lyon",
  label: "Lyon (69002) 2e Arrondissement",
  lat: 45.75917,
  lng: 4.82965,
  zipcode: "69002",
  geo_source: "city",
  geo_provider: "here",
  region: "22",
  region_label: "Rhône-Alpes",
  department: "69",
  dpt_label: "Rhône",
  country: "FR",
};


export default {
  marseille: LOCATION_MARSEILLE,
  toulouse: LOCATION_TOULOUSE,
  lyon: LOCATION_LYON,
  paris: LOCATION_PARIS,
  bordeaux: LOCATION_BORDEAUX,
}